export const SSO_PROMPT_SELECT_ACCOUNT = "select_account";
